import { AlertCircle } from "lucide-react";

export const BillingAccessRestrictedView = () => {
  return (
    <div className="min-h-screen bg-background">
      <section className="pb-20 pt-10">
        <div className="container mx-auto flex min-h-[400px] items-center justify-center px-4">
          <div className="flex max-w-md flex-col items-center gap-4 text-center">
            <AlertCircle className="h-12 w-12 text-warning" />
            <h2 className="text-2xl font-bold text-foreground">Billing access restricted</h2>
            <p className="text-muted-foreground">
              You don&apos;t have permission to view or manage billing for this firm. Please contact
              a firm administrator if you need help with subscriptions or payment.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
